import { prefixRelativeUrl } from './util';
import '../vendor/toc/bootstrap-toc';
import './flatpickr/flatpickr-config.js';
import './components/site-menu';
import './components/site-menu-responsive';
import './components/find-on-page-responsive';
import './components/context-menu';
import './components/youtube-block';
import './components/occurance-switcher';
import './components/add-to-cart';
import './components/listitem-to-cart';
import './components/editable-table';
import './components/select-content';
import './components/checkout-page';
import './components/inquiry';
import './components/faq';
import './components/related-areas-block';
import './components/search';
import './components/forms';
import './components/bootstrapform';
import './components/registrationform';
import './components/LiveSurvey/Common';
import './components/LiveSurvey/Dashboard';
import './components/LiveSurvey/User';
import './components/sliders';
import './components/checklist-search.js';
import './components/apsis-subscribe';
import './components/Inquiry/inquiry-result';
import './components/explain-word';
import './components/dilemma-container-block';
import './components/dilemma-block';
import './components/rotating-word-block';
import './components/book-list';
import './components/dropdown-list-component.js';

Toc.init({
    $nav: $('#toc'),
    $scope: $('main h2')
});

$(document).ready(function () {
    $('main a[href^="http"], #context-menu a[href^="http"]')
        .not('.cta, .search-hit, .copylink, .button')
        .append(
            `<svg class="external-link ml-1 pb-1">
        <use href="${prefixRelativeUrl('/dist/spritemap.svg#sprite-external-link')}"></use>
      </svg>`
        );
});

window.addEventListener('pageshow', function (event) {
    var historyTraversal =
        event.persisted ||
        (typeof window.performance != 'undefined' && window.performance.navigation.type === 2);

    if (historyTraversal) {
        // Check cart when traveling in history, in case user added an item and then goes back in history to persist the visual count in the menu.

        $.get({
            url: `/api/commerce/cart`,
            contentType: `application/json`
        }).done((data) => {
            $('.shopping-cart-top-link .shopping-cart-icon__count').text(data.payload.totalCount);
            if (data.payload.totalCount == 0) {
                $('.shopping-cart-top-link .shopping-cart-icon').addClass(
                    'shopping-cart-icon--empty'
                );
            } else {
                $('.shopping-cart-top-link .shopping-cart-icon').removeClass(
                    'shopping-cart-icon--empty'
                );
            }
        });
    }
});
